// extracted by mini-css-extract-plugin
module.exports = {"page":"HomePage_page__3DVuJ","container":"HomePage_container__WlGIt"};